'use client';

import AppImage from '@/components/ui/AppImage';

interface Partner {
  name: string;
  logo: string;
  alt: string;
}

const PartnersRibbon = () => {
  const partners: Partner[] = [
    {
      name: 'BIRAC',
      logo: '/assets/images/bir-1767634561396.png',
      alt: 'BIRAC - Biotechnology Industry Research Assistance Council logo'
    },
    {
      name: 'Venture Center',
      logo: '/assets/images/vc-1767634755958.png',
      alt: 'Venture Center - Technology Business Incubator logo'
    },
    {
      name: 'C-CAMP',
      logo: '/assets/images/ccmp-1767634795572.png',
      alt: 'C-CAMP - Centre for Cellular and Molecular Platforms logo'
    },
    {
      name: 'Startup Karnataka',
      logo: '/assets/images/karnat-1767634856474.png',
      alt: 'Startup Karnataka - Government of Karnataka startup initiative logo'
    },
    {
      name: 'Grand Challenges Canada',
      logo: '/assets/images/gcc-1767634959697.png',
      alt: 'Grand Challenges Canada - Funding bold ideas with big impact logo'
    },
    {
      name: 'Millennium Alliance',
      logo: '/assets/images/mallianca-1767636161764.png',
      alt: 'Millennium Alliance - Advancing innovations for development logo'
    },
    {
      name: 'Infosys Foundation',
      logo: '/assets/images/info-1767636191613.png',
      alt: 'Infosys Foundation - Empowering communities through education and healthcare logo'
    },
    {
      name: 'SELCO Foundation',
      logo: '/assets/images/selco-1767636270826.png',
      alt: 'SELCO Foundation - Sustainable energy solutions for poverty alleviation logo'
    },
    {
      name: 'Social Alpha',
      logo: '/assets/images/sa-1767636351700.png',
      alt: 'Social Alpha - Science and technology based social impact innovations logo'
    },
    {
      name: 'PATH',
      logo: '/assets/images/path-1767636436098.png',
      alt: 'PATH - Global health innovation organization logo'
    }
  ];

  return (
    <section className="py-12 bg-surface border-y border-border">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold font-heading text-foreground mb-2">
            Our Partners
          </h3>
          <p className="text-muted-foreground">
            Supported by leading institutions in innovation and healthcare
          </p>
        </div>
        
        <div className="grid grid-cols-5 gap-4 items-center">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="flex items-center justify-center p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-250"
            >
              <AppImage
                src={partner.logo}
                alt={partner.alt}
                className="h-12 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersRibbon;